import { Navigate, useSearchParams } from 'react-router-dom'

/** 兼容旧链接 /manage/login → 统一登录页 */
export default function AdminLoginRedirect() {
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || '/manage/users'
  return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />
}
